import { IconFiles, IconTextPlus } from "@tabler/icons-react";
import * as M from "@mantine/core";
import { useNavigate } from "react-router-dom";

export interface IPropsControlSections {
  isEndUser: boolean;
  currentPathname: string;
  onClickDeleteDevice: () => void;
  open: () => void;
}

export default function ControlSections(props: IPropsControlSections) {
  const navigate = useNavigate();
  const { isEndUser, currentPathname, onClickDeleteDevice, open } = props;

  return (
    <M.Group>
      {!isEndUser && (
        <>
          <M.Menu shadow="md" width={114} position="bottom">
            <M.Menu.Target>
              <M.Button color="secondary.5" variant="filled">
                등록
              </M.Button>
            </M.Menu.Target>
            <M.Menu.Dropdown>
              <M.Menu.Item
                fw="normal"
                leftSection={<IconTextPlus size={18} />}
                onClick={() => navigate(currentPathname + "/register")}
              >
                개별 등록
              </M.Menu.Item>
              <M.Menu.Item
                fw="normal"
                leftSection={<IconFiles size={18} />}
                onClick={open}
              >
                엑셀 등록
              </M.Menu.Item>
            </M.Menu.Dropdown>
          </M.Menu>
          <M.Button variant="outline" onClick={onClickDeleteDevice}>
            선택 삭제
          </M.Button>
        </>
      )}
    </M.Group>
  );
}
